import {
  Button,
  Container,
  Flex,
  Text,
  useBreakpointValue
} from '@chakra-ui/react'
import { useSessionManagement } from '@context'
import { useExperienceManager } from '@hooks'
import { Lock } from '@material-ui/icons'
import React, { useEffect, useRef, useState } from 'react'
import ProgressNoteFeedback from './progress-note-feedback-v2'

export const ProgressNoteFooterV2 = ({
  noteType
}: {
  handleCopyAllToClipboard: any
  noteType: string
  openSettings: () => void
}) => {
  const { isExtension, isWidget } = useExperienceManager()

  const buttonsHaveTextBreakpoint = useBreakpointValue({
    base: false,
    sm: true
  })

  const {
    isLockingNote,
    handleLockNote,
    isNoteLocked,
    progressNoteData,
    sessionId
  } = useSessionManagement()
  let buttonSpacing = useBreakpointValue({ base: '0px', sm: '0px' })

  if (isWidget || isExtension) {
    buttonSpacing = '8px'
  }
  const [parentWidth, setParentWidth] = useState(0)
  const parentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const updateWidth = () => {
      if (parentRef.current) {
        setParentWidth(parentRef.current.offsetWidth)
      }
    }

    window.addEventListener('resize', updateWidth)
    updateWidth()

    return () => window.removeEventListener('resize', updateWidth)
  }, [])

  const progressNotes = progressNoteData?.sessionProgressNotes || []

  const overrideButtonsHaveText = !parentRef?.current || parentWidth > 540
  const buttonsHaveText = buttonsHaveTextBreakpoint && overrideButtonsHaveText
  const hasMultipleVersions = progressNotes?.length > 1
  const isIntegratedUI = isExtension || isWidget

  return (
    <Container bg="white" borderTop="1px solid" borderColor="pale_gray">
      <Flex
        id="progress-note-footer"
        w="100%"
        alignItems="center"
        justifyContent="space-between"
        {...(!isIntegratedUI
          ? { gap: '16px' }
          : { maxWidth: '750px', margin: '0 auto' })}
        ref={parentRef}
        py={isIntegratedUI ? '10px' : '16px'}
      >
        <Flex alignItems="center">
          {!isNoteLocked && (
            <ProgressNoteFeedback
              sessionId={sessionId}
              parentRef={parentRef}
              parentWidth={parentWidth}
              hasMultipleVersions={hasMultipleVersions}
              progressNotes={progressNotes}
              noteType={noteType}
            />
          )}
        </Flex>
        <Flex alignItems="center">
          <Button
            id={`pendo-lock-note-button`}
            borderRadius="4px"
            onClick={() => handleLockNote()}
            variant="outline"
            m={`0 0 0 ${buttonSpacing}`}
            h="35px"
            borderColor="pale_gray"
            {...(!buttonsHaveText
              ? { w: '35px', minW: '35px', maxW: '35px' }
              : {})}
            isLoading={isLockingNote}
            disabled={isNoteLocked || isLockingNote}
            _hover={{ opacity: isNoteLocked || isLockingNote ? 0.7 : 'none' }}
            _focus={{ outline: 'none' }}
            data-click-text="Lock note"
          >
            <Flex align="center" justify="space-between">
              <Lock />
              {buttonsHaveText && <Text ml="5px">Sign and lock note</Text>}
            </Flex>
          </Button>
        </Flex>
      </Flex>
    </Container>
  )
}
